import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  Group,
  Menu,
  NumberFormatter,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandVisa,
  IconCheck,
  IconDownload,
  IconEye,
  IconMenuOrder,
  IconReceiptTax,
  IconReload,
  IconRocket,
  IconSearch,
  IconSortAscending,
  IconSquareXFilled,
  IconStatusChange,
  IconTransformFilled,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useMemo, useState, useTransition } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useHotkeys, useIsFirstRender } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconReceiptRefund,
  IconTimeDuration15,
} from "@tabler/icons-react";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import {
  keySearchApproveApplicationList,
  repositoryPos,
  styleTableMantine,
  styleTableMantineExpress,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import useDynamicHeight from "../../../_base/component/Core/hookBase";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById, isJSON } from "../../../_base/helper/FunctionHelper";
import { SocketExtension } from "../../../_base/socket/socket";
import { CREATEORDERSUCCESS } from "../../../_base/socket/ToplicList";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { BASE_API_POS } from "../../../config";
import { _localization } from "../../../config/location";
import { green, olive_green, sky_blue } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItem } from "../../../model/SelectListItem";
import DetailsSellView from "../DetailsSellView";
import ExportVAT from "../ExportVAT";
import CloseOrderButton from "../RetailOrder/ModalComponent/CloseOrderButton";
import SalesDeleteOrder from "../SalesDeleteOrder";

// Định nghĩa đúng kiểu dữ liệu
type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ApproveApplicationList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //data and fetching state
  const [isHaveNewOrder, setIsHaveNewOrder] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  const [listEmployeeSales, setListEmployeeSales] = useState<any[]>([]);

  const dataChannel = [
    {
      text: "Lazada",
      value: "304",
    },
    {
      text: "Tiktok",
      value: "341",
    },
    {
      text: "Chat Zalo",
      value: "343",
    },
    {
      text: "Facebook",
      value: "62",
    },
    {
      text: "Shopee Mall",
      value: "63",
    },
    {
      text: "Shopee",
      value: "342",
    },
    {
      text: "Tổng đài",
      value: "66",
    },
    {
      text: "Khách đến showroom",
      value: "67",
    },
    {
      text: "Khách đặt đơn Website",
      value: "68",
    },
    {
      text: "Khách gọi điện cho nhân viên",
      value: "69",
    },
    {
      text: "Khách chat qua website",
      value: "101",
    },
  ];

  const dataStatusGeneral = [
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Đơn hàng tạm", value: "DON_HANG_TAM" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "Đơn hàng chờ duyệt giảm", value: "DON_HANG_CHO_DUYET_GIAM" },
    { label: "Đơn chờ duyệt đổi trả", value: "DON_CHO_DUYET_DOI_TRA" },
    { label: "Đơn đã duyệt đổi trả", value: "DON_DA_DUYET_DOI_TRA" },
    { label: "GV thành công", value: "GV_THANH_CONG" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đã phân công GV", value: "DA_PHAN_CONG_GV" },
    { label: "GV đến nơi", value: "GV_DEN_NOI" },
    { label: "GV đang giao", value: "GV_DANG_GIAO" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
    { label: "Hủy phân công GV", value: "HUY_PHAN_CONG_GV" },
    { label: "Thất bại do HACOM", value: "THAT_BAI_DO_HACOM" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "Đơn hàng chốt", value: "DON_HANG_CHOT" },
    { label: "Đơn hàng đã duyệt giảm", value: "DON_HANG_DA_DUYET_GIAM" },
    { label: "GV tiếp nhận", value: "GV_TIEP_NHAN" },
    { label: "GV nhập lại", value: "GV_NHAP_LAI" },
    { label: "GV nhập lại một phần", value: "GV_NHAP_LAI_MOT_PHAN" },
    { label: "GV thất bại do HACOM", value: "GV_THAT_BAI_DO_HACOM" },
    { label: "GV thất bại do KH", value: "GV_THAT_BAI_DO_KH" },
    { label: "GV nối chuyến", value: "GV_NOI_CHUYEN" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "Có nhập lại", value: "CO_NHAP_LAI" },
    { label: "KH đã nhận", value: "DA_NHAN" },
  ];

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const _searchJson = localStorage.getItem(keySearchApproveApplicationList)
    ? JSON.parse(localStorage.getItem(keySearchApproveApplicationList) ?? "")
    : null;
  const firstRender = useIsFirstRender();
  //table state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  } as MRT_PaginationState);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const height = useDynamicHeight(360);
  const innitSearchReturn = {
    customerName: "",
    customerCode: "",
    customerTaxCode: "",
    serial: "",
    orderNumber: "",
    phone: "",
    keySearch: "",
    codeSal: "",
  };

  // console.log("_searchJson", _searchJson);
  const innitStateSearch = useMemo(
    () => ({
      invId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.InvId as string)
          : "",
      invOutwardId:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.InvOutwardId
          : "",
      customerId: firstRender && _searchJson ? _searchJson.CustomerId : "",
      StartDate:
        firstRender && _searchJson && _searchJson.StartDate && checkedPinSearch
          ? new Date(_searchJson.StartDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() - 9)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      EndDate:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.EndDate &&
        _searchJson.EndDate != null
          ? new Date(_searchJson.EndDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      orderStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderStatus
          : "",
      orderType:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderType
          : "",
      orderNumber:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderNumber
          : "",
      paymentStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.PaymentStatus
          : "",
      industry:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.Industry
          : "",
      keySearch:
        checkedPinSearch && firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KeySearch
          : "",
      OutwardStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OutwardStatus
          : "",
      codeCustomer:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.CodeCustomer
          : "",
      phone:
        checkedPinSearch && firstRender && _searchJson ? _searchJson.Phone : "",
      createBy:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.CreateBy
          : "",
      //Người hưởng số
      CodeSal:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CodeSal as string)
          : "",
      //Thời gian hoàn thành đơn
      FinishDate:
        firstRender && _searchJson && _searchJson.FinishDate && checkedPinSearch
          ? new Date(_searchJson.FinishDate)
          : null,
      //Ngày xuất kho
      OwDate:
        firstRender && _searchJson && _searchJson.OwDate && checkedPinSearch
          ? new Date(_searchJson.OwDate)
          : null,
      // Số điện thoại người bán
      SalePhone:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.SalePhone
          : "",
      // Mã voucher
      VourcherCode:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.VourcherCode
          : "",
      SourceOrderType:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.SourceOrderType
          : false,
      SortType:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.SortType
          : "",
    }),
    [firstRender, _searchJson],
  );

  const [searchReturn, setSearchReturn] = useState({
    ...innitSearchReturn,
  });
  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  const [refreshKeySearch, setRefreshKeySearch] = useState<any>({});

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const handleCheckPayment = async (row: any) => {
    const url = `/api/v1/CreateSellItem/payment?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.orderNumber.includes("DT")) {
        navigate("/sell/payment-order-return", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "payment",
          },
        });
      } else {
        navigate("/sell/payment-order", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "payment",
          },
        });
      }
    }
  };

  //   const handleCheckApproved = async (row: any) => {
  //     const url = `/api/v1/CreateSellItem/approve?orderNumber=${row.original.orderNumber}`;
  //     const response = await repositoryPos.get<MessageResponse<any>>(url);
  //     if (response && response.success) {
  //       if (row.original.orderNumber.includes("DT")) {
  //         navigate("/sell/approved-discount-order-return", {
  //           state: {
  //             orderNumber: row.original.orderNumber,
  //             orderType: row.original.orderType,
  //             actionType: "approved",
  //           },
  //         });
  //       } else {
  //         navigate("/sell/approved-discount-order", {
  //           state: {
  //             orderNumber: row.original.orderNumber,
  //             orderType: row.original.orderType,
  //             actionType: "approved",
  //           },
  //         });
  //       }
  //     }
  //   };

  //   const handleCheckEdit = async (row: any) => {
  //     // check thêm orderType
  //     const url = `/api/v1/CreateSellItem/edit?orderNumber=${row.original.orderNumber}`;
  //     const response = await repositoryPos.get<MessageResponse<any>>(url);

  //     if (response && response.success) {
  //       if (row.original.orderType === "1") {
  //         navigate("/sell/revise-whole-order", {
  //           state: {
  //             orderNumber: row.original.orderNumber,
  //             orderType: row.original.orderType,
  //             actionType: "edit",
  //           },
  //         });
  //       } else {
  //         navigate("/sell/revise-order", {
  //           state: {
  //             orderNumber: row.original.orderNumber,
  //             orderType: row.original.orderType,
  //             actionType: "edit",
  //           },
  //         });
  //       }
  //     }
  //   };

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.orderNumber.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
            // isReadOnly:
            //   location?.pathname === "/sell/sales-order-list-read-only"
            //     ? true
            //     : false,
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
            // isReadOnly:
            //   location?.pathname === "/sell/sales-order-list-read-only"
            //     ? true
            //     : false,
          },
        });
      }
    }
  };

  const getTextStatus = (row: any) => {
    return orderStatuses.find(
      (status) => status.value === row.original.orderStatus,
    )?.label;
  };

  const getShippingVendorText = (shippingVendor: string) => {
    switch (shippingVendor) {
      case "KHONG":
        return "Nhận tại cửa hàng";
      case "HACOM":
        return "Nội bộ";
      default:
        return shippingVendor;
    }
  };
  const fetchData = async () => {
    if (form.getValues()?.StartDate && form.getValues()?.EndDate) {
      setIsLoading(true);
      //   setIsRefetching(true);
      // setIsError(false);

      let queryParams = {
        Skip:
          firstRender && _searchJson
            ? _searchJson.Skip
            : pagination.pageIndex * pagination.pageSize,
        Take:
          firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
      } as any;
      try {
        // if (!firstRender) {
        const search = form.getValues();
        queryParams = {
          ...queryParams,
          // Skip: pagination.pageIndex * pagination.pageSize,
          // Take: pagination.pageSize,
          InvId: search.invId?.toString(),
          InvOutwardId: search.invOutwardId?.toString(),
          CustomerId: search.customerId?.toString(),
          StartDate: search.StartDate
            ? moment(search?.StartDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "",
          EndDate: search.EndDate
            ? moment(search?.EndDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "",
          OrderStatus: search.orderStatus?.toString(),
          OrderType: search.orderType ? search.orderType?.toString() : 0,
          OrderNumber: search.orderNumber?.toString()?.toUpperCase(),
          PaymentStatus: search.paymentStatus?.toString(),
          industry: search.industry?.toString(),
          OutwardStatus: search?.OutwardStatus?.toString(),
          KeySearch: search.keySearch?.toString(),
          CodeCustomer: search.codeCustomer?.toString(), // Thêm trường tìm kiếm mã khách hàng
          Phone: search.phone?.toString(), // Thêm trường tìm kiếm số điện thoại
          CreateBy: search.createBy?.toString(), // Thêm trường tìm kiếm người tạo
          CodeSal: search.CodeSal?.toString(), //Thêm người hưởng số
          FinishDate: search.FinishDate
            ? moment(search?.FinishDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "", //Thời gian hoàn thành đơn
          OwDate: search.OwDate
            ? moment(search?.OwDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "", //ngày xuất kho
          SalePhone: search.SalePhone?.toString(), // Số điện thoại người bán
          VourcherCode: search.VourcherCode?.toString(), // Mã voucher
          SourceOrderType: search.SourceOrderType ? "4" : "",
          SortType: search.SortType || "",
        };

        const queryParamsReturn = {
          Skip: pagination.pageIndex * pagination.pageSize,
          Take: pagination.pageSize,
          CustomerName: searchReturn.customerName,
          CustomerCode: searchReturn.customerCode,
          CustomerTaxCode: searchReturn.customerTaxCode,
          Serial: searchReturn.serial,
          OrderNumber: searchReturn.orderNumber,
          Phone: searchReturn.phone,
          KeySearch: searchReturn.keySearch,
          CodeSal: searchReturn.codeSal,
        };

        let url;

        url =
          "/api/v1/CreateSellItem/get-list?IsAccountant=true&" +
          Object.entries(queryParams)
            .filter(([, value]) => value !== undefined && value !== "")
            .map(
              ([key, value]) =>
                `${key}=${encodeURIComponent(
                  value as string | number | boolean,
                )}`,
            )
            .join("&");
        //   console.log(queryParams);
        const response = await repositoryPos.get<MessageResponse<any>>(url);

        if (response && response.success) {
          setData(response.data?.pagedList?.lists);
          startTransition(() => {
            setRowCount(response.totalCount);
            //     table.resetRowSelection();
          });
        }
      } catch (error) {
        //   setIsError(true);
        console.error(error);
      } finally {
        setIsLoading(false);
        //   setIsRefetching(false);
        localStorage.setItem(
          keySearchApproveApplicationList,
          JSON.stringify(queryParams),
        );
      }
    } else {
      NotificationExtension.Fails("Vui lòng chọn khoảng thời gian tìm kiếm !");
    }
  };

  //hàm hủy đơn hàng
  const DeleteCancelOrder = (value: any, status: any, isWeb: any) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Hủy đơn hàng!</Title>
        </>
      ),
      size: "auto",
      children: (
        <SalesDeleteOrder
          idItems={value}
          status={status}
          onSearch={fetchData}
          onClose={setDeleteViewStatus}
          web={isWeb ? true : false}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const orderTypes = [
    { value: "1", label: "Bán buôn", color: "yellow" },
    { value: "2", label: "Bán lẻ", color: "indigo" },
    { value: "3", label: "Đơn đổi trả", color: "green" },
    { value: "4", label: "Đơn online", color: "blue" },
  ];

  const orderStatuses = [
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
    { value: "DON_CHO_DUYET_DOI_TRA", label: "Đơn chờ duyệt đổi trả" },
    { value: "DON_DA_DUYET_DOI_TRA", label: "Đơn đã duyệt đổi trả" },
  ];

  const warehouseStatus = [
    { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
    { value: "DANG_XUAT", label: "Đang xuất" },
    { value: "DA_XUAT", label: "Đã xuất" },
    { value: "DANG_NHAP", label: "Đang nhập" },
    { value: "DA_NHAP", label: "Đã nhập" },
  ];

  const openModal = (document: any, amount: number, order: string) =>
    modals.openConfirmModal({
      title: <Title order={4}>Danh sách sản phẩm trong đơn: {order}</Title>,
      children: <DetailsSellView e={document} amount={amount} />,
      size: "100%",
      radius: "md",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 80,
        // enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) =>
          String(row.original.shippingPriority) === "1" ? (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                size="md"
                style={{ cursor: "pointer" }}
                leftSection={<IconRocket size={12} />}
                color={"red"}
                onDoubleClick={() => handleCheckView(row)}
              >
                {renderedCellValue === null
                  ? "KHÔNG HỢP LỆ"
                  : renderedCellValue}
              </Badge>
            </Tooltip>
          ) : (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                variant="dot"
                size="md"
                style={{ cursor: "pointer" }}
                color={renderedCellValue === null ? "red" : green.base}
                onDoubleClick={() => handleCheckView(row)}
              >
                {renderedCellValue === null
                  ? "KHÔNG HỢP LỆ"
                  : renderedCellValue}
              </Badge>
            </Tooltip>
          ),
      },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const orderStatus = row.original.orderStatus;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "DON_CHO_DUYET_DOI_TRA":
              badgeColor = "orange";
              break;
            case "DON_DA_DUYET_DOI_TRA":
              badgeColor = "teal";
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {row.original.orderStatus !== null
                ? getTextStatus(row)
                : "Không HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute12",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataStatusGeneral,
              "label",
            )?.toUpperCase() || renderedCellValue}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "attribute3",
        header: "Trạng thái kho",
        Cell: ({ renderedCellValue, row }) => {
          const _status = warehouseStatus.find(
            (status) => status.value === row?.original?.attribute3?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute37",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderType",
        header: "Loại đơn hàng",
        size: 150,
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const orderType = orderTypes.find(
            (type) => type.value === row.original.orderType?.toString(),
          );

          return (
            <Badge color={orderType?.color || "gray"}>
              {orderType?.label || "KHÔNG HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute16",
        header: "Mã ĐTCN",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "saleChannelId",
        header: "Kênh bán",
        Cell: ({ renderedCellValue }) => {
          const saleChannel = dataChannel.find(
            (channel) => channel.value === renderedCellValue?.toString(),
          );
          return saleChannel?.text || "KHÔNG HỢP LỆ";
        },
      },
      {
        accessorKey: "invOrgName",
        header: "Kho hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{`[${row.original.invOrgCode}] ${row.original.invOrgName}`}</>
        ),
      },
      {
        accessorKey: "sale",
        header: "Nhân viên bán hàng",
        size: 180,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ renderedCellValue }) => (
        //   <>
        //     <AvatarUtils
        //       value={renderedCellValue?.toString().split("-")[0] ?? ""}
        //     />
        //   </>
        // ),
      },
      {
        accessorKey: "nvhs",
        header: "Người hưởng số",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "salePhone",
        header: "Số đt người bán",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "creator",
        header: "Người tạo đơn đổi trả",
        // enableColumnActions: false,,
        size: 200,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          // Kiểm tra nếu orderType === 3 thì hiển thị, ngược lại không hiển thị
          return row.original.orderType == 3 ? <>{row.original.creator}</> : "";
        },
      },
      // {
      //   accessorKey: "attribute18",
      //   header: "Người hưởng doanh số",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      //   Cell: ({ renderedCellValue }) => (
      //     <>
      //       <AvatarUtils
      //         value={renderedCellValue?.toString().split("-")[0] ?? ""}
      //       />
      //     </>
      //   ),
      // },
      {
        accessorKey: "creationDate",
        header: "Ngày lập",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderDate",
        header: "Ngày hoàn thành",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      // {
      //   accessorKey: "address",
      //   header: "Địa chỉ",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      // },
      {
        accessorKey: "technicalChecked",
        header: "Dịch vụ kiểm tra",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => (
          <>
            {
              <>
                {(() => {
                  if (row.original.technicalChecked === 0) {
                    return <Badge color="indigo">Không yêu cầu</Badge>;
                  } else if (row.original.technicalChecked === 1) {
                    return <Badge color="grape">Lắp ráp(mới)</Badge>;
                  } else if (row.original.technicalChecked === 2) {
                    return <Badge color="cyan">Kiểm tra(mới)</Badge>;
                  } else if (row.original.technicalChecked === 3) {
                    return (
                      <Badge color={sky_blue.medium}>
                        Lắp ráp(mới)+Kiểm tra(mới)
                      </Badge>
                    );
                  } else {
                    return null; // Or any fallback UI if needed
                  }
                })()}
              </>
            }
          </>
        ),
      },
      {
        accessorKey: "attribute11",
        header: "KT đã kiểm tra",
        size: 260,
        Cell: ({ row }) => (
          <Badge color="blue">
            {row?.original?.attribute11
              ? row?.original?.attribute11
              : "Khách không yêu cầu kiểm tra"}
          </Badge>
        ),
      },
      {
        accessorKey: "deliveryStatus",
        header: "Trạng thái giao vận",
        Cell: ({ renderedCellValue, row }) => (
          <Badge size="sm" color="cyan">
            {row?.original?.deliveryStatus === null
              ? "KHONG_YEU_CAU"
              : row?.original?.deliveryStatus}
          </Badge>
        ),
      },
      {
        accessorKey: "shipingVendor",
        header: "Bộ phận giao hàng",
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{getShippingVendorText(row?.original?.shipingVendor ?? "")}</>
        ),
      },
      {
        accessorKey: "tenNVGV",
        header: "Tên NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "sdtNVGV",
        header: "SĐT NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute46",
        header: "Thời gian GV tiếp nhận đơn",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "attribute45",
        header: "Thời gian GV hoàn thành đơn",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "customerName",
        header: "Tên khách hàng",
        enableColumnFilter: false,
      },
      {
        accessorKey: "customerPhone",
        header: "Điện thoại KH",
        size: 160,
        enableColumnFilter: false,
      },
      {
        accessorKey: "amount",
        header: "Số tiền",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            thousandSeparator=","
          />
        ),
      },
      {
        accessorKey: "paid",
        header: "Đã trả",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "remaining",
        header: "Còn nợ",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            thousandSeparator=","
          />
        ),
      },
      {
        accessorKey: "printInvoiceCheck",
        header: "Xuất hóa đơn",
        enableColumnFilter: false,
        Cell: ({ row }) => <>{row.original.printInvoiceCheck}</>,
      },
      {
        accessorKey: "attribute39",
        header: "Mã voucher",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute27",
        header: "Số hóa đơn",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 155,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, row }) => (
          <Flex gap={10}>
            <Tooltip label="Danh sách sản phẩm trong đơn">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={() =>
                  openModal(
                    row.original.orderDetail,
                    row.original.amount,
                    row.original.orderNumber,
                  )
                }
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Menu position="left">
              <Menu.Target>
                <Tooltip label="Thông tin xuất hóa đơn VAT">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="#15AABF"
                    disabled={row.original.attribute57 === null}
                  >
                    <IconReceiptTax size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </Menu.Target>
              <Menu.Dropdown>
                <ExportVAT
                  data={row.original.attribute57}
                  code={row.original.orderNumber}
                />
              </Menu.Dropdown>
            </Menu>
            {location.pathname !== "/sell/sales-order-list-read-only" && (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {location.pathname == "/sell/sales-order-list-read-only" &&
                  row.original?.orderStatus === "DON_HANG_HOAN_THANH" &&
                  !row?.original?.t9 && (
                    <>
                      <Tooltip label="Trả hàng">
                        <ActionIcon
                          variant="light"
                          aria-label="Settings"
                          color="red"
                        >
                          <IconTransformFilled
                            size={20}
                            onClick={() =>
                              navigate("/sell/return-order", {
                                state: {
                                  orderNumber: row.original.orderNumber,
                                  actionType: "return",
                                },
                              })
                            }
                          />
                        </ActionIcon>
                      </Tooltip>
                    </>
                  )}

                {location.pathname == "/sell/sales-order-list-read-only" &&
                  row.original?.orderStatus === "DON_HANG_HOAN_THANH" &&
                  row.original?.t9 && (
                    <>
                      <Tooltip label="Đổi hàng">
                        <ActionIcon
                          variant="light"
                          aria-label="Settings"
                          color="lime"
                        >
                          <IconReceiptRefund
                            size={20}
                            onClick={() =>
                              navigate("/sell/exchange-order", {
                                state: {
                                  orderNumberOld: row.original.orderNumber,
                                  actionType: "doi",
                                },
                              })
                            }
                          />
                        </ActionIcon>
                      </Tooltip>
                    </>
                  )}

                {row.original.orderStatus === "DON_HANG_HOAN_THANH" &&
                row.original.attribute30 !== "1" ? (
                  <CloseOrderButton
                    row={row}
                    fetchData={() => fetchData()}
                  ></CloseOrderButton>
                ) : (
                  <>
                    {row.original.orderStatus !== "DON_HANG_HUY" &&
                    row.original.orderStatus !== "KHO_XUAT_HANG" &&
                    row.original.orderStatus !== "DON_HANG_DOI_TRA" &&
                    row.original.orderStatus !== "DON_HANG_DOI_TRA_TAM" ? (
                      <>
                        {/* {row.original.orderStatus === "DON_HANG_TAM" && (
                          <Tooltip label="Sửa đơn">
                            <ActionIcon
                              disabled={
                                row.original.orderStatus ===
                                  "DON_HANG_HOAN_THANH" ||
                                row.original.orderStatus === null
                              }
                              variant="light"
                              aria-label="Settings"
                              color="yellow"
                            >
                              <IconEdit
                                size={20}
                                onClick={() => {
                                  handleCheckEdit(row);
                                }}
                              />
                            </ActionIcon>
                          </Tooltip>
                        )} */}

                        {(row.original.orderStatus === "DON_HANG_CHOT" ||
                          row.original.orderStatus ===
                            "DON_HANG_DA_DUYET_GIAM" ||
                          row.original.orderStatus ===
                            "DON_DA_DUYET_DOI_TRA") && (
                          <Tooltip label="Thanh toán">
                            <ActionIcon
                              disabled={
                                row.original.orderStatus ===
                                  "DON_HANG_HOAN_THANH" ||
                                row.original.orderStatus === null
                              }
                              variant="light"
                              aria-label="Settings"
                              color="green"
                            >
                              <IconBrandVisa
                                size={20}
                                onClick={() => {
                                  handleCheckPayment(row);
                                }}
                              />
                            </ActionIcon>
                          </Tooltip>
                        )}
                        {/* {(row.original.discountAdded > 0 ||
                          row.original.discountAddedTotal > 0) &&
                          row.original.approveStatus !== 1 &&
                          row.original.orderStatus ===
                            "DON_HANG_CHO_DUYET_GIAM" && (
                            <Tooltip label="Duyệt giảm">
                              <ActionIcon
                                disabled={
                                  row.original.orderStatus ===
                                    "DON_HANG_HOAN_THANH" ||
                                  row.original.orderStatus === null
                                }
                                variant="light"
                                aria-label="Settings"
                                color="violet"
                                onClick={() => {
                                  handleCheckApproved(row);
                                }}
                              >
                                <IconCoin size={20} onClick={() => {}} />
                              </ActionIcon>
                            </Tooltip>
                          )} */}
                      </>
                    ) : null}

                    {row.original.orderStatus !== "DON_HANG_HUY" &&
                    row.original.orderStatus !== "KHO_XUAT_HANG" &&
                    row.original.orderStatus !== "DON_HANG_DOI_TRA" &&
                    row.original.orderStatus !== "DON_HANG_DONG" ? (
                      <Tooltip
                        disabled={
                          row.original.orderStatus === "DON_HANG_HOAN_THANH"
                        }
                        label="Hủy đơn"
                      >
                        <ActionIcon
                          variant="light"
                          aria-label="Settings"
                          color="red"
                          disabled={
                            row.original.orderStatus === "DON_HANG_HOAN_THANH"
                          }
                          onClick={async () => {
                            DeleteCancelOrder(
                              row.original.orderNumber,
                              row.original.orderStatus,
                              row.original.attribute49,
                            );
                          }}
                        >
                          <IconSquareXFilled size={20} stroke={1.5} />
                        </ActionIcon>
                      </Tooltip>
                    ) : null}
                  </>
                )}
              </Box>
            )}
          </Flex>
        ),
      },
    ],
    [location.pathname, dataStatusGeneral],
  );

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  //Lưu ghim cột
  const getColumnPinningStorage = () => {
    try {
      const columnPinningStorage = localStorage.getItem(
        "approveApplicationListColumnPinning",
      );
      return columnPinningStorage
        ? JSON.parse(columnPinningStorage)
        : { left: ["STT", "orderNumber"], right: ["action"] }; // Giá trị mặc định
    } catch (error) {
      console.error("Error parsing column pinning storage:", error);
      return { left: ["STT", "orderNumber"], right: ["action"] };
    }
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(() =>
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    try {
      localStorage.setItem(
        "approveApplicationListColumnPinning",
        JSON.stringify(columnPinning),
      );
    } catch (error) {
      console.error("Error saving column pinning to localStorage:", error);
    }
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    onColumnPinningChange: setColumnPinning,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: {
        maxHeight: height,
        minHeight: height,
        overflowX: "auto",
        overflowY: "auto",
      },
    },
    enableStickyHeader: true,
    enableExpanding: false,
    // onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style:
        String(row.original.shippingPriority) === "1"
          ? {
              fontWeight: "500",
              fontSize: "11.5px",
              padding: "6px 8px",
              color: "red",
            }
          : styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      // showAlertBanner: isError,
      // showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // displayColumnDefOptions: {
    //   "mrt-row-select": {
    //     size: 1,
    //   },
    //   "mrt-row-expand": {
    //     size: 1,
    //   },
    // },
  });

  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    deleteViewStatus,
    refreshKeySearch,
  ]);

  useEffect(() => {
    SocketExtension.On(CREATEORDERSUCCESS, (arg: any) => {
      // fetchData();
      setIsHaveNewOrder(true);
    });
    return () => {
      SocketExtension.Off(CREATEORDERSUCCESS, () => {});
    };
  }, []);

  const renderSelectOption: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={orderTypes.find((x) => x.value === option.value)?.color}
        radius="sm"
        variant="filled"
      ></Badge>
      {option.label}{" "}
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  // // Lấy key search vào ở local storage
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    startTransition(() => {
      fetchDataBranch();
    });
  }, []);

  useEffect(() => {
    if (!checkedPinSearch) {
      form.setValues((prev) => ({ ...prev, keySearch: "" }));
    }
  }, [checkedPinSearch]);
  useHotkeys([["Enter", () => fetchData()]]);

  useEffect(() => {
    const fetchEmployeeBy = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/get-all`,
      );
      if (response && response.success) {
        const result = response.data;
        const formattedData = result.map((employee: any) => ({
          value: employee.code, // Giá trị cho "value"
          label: `${employee.fullname}-${employee.code}`, // Giá trị cho "label"
        }));
        setListEmployeeSales(formattedData); // Lưu mảng đã format vào state
      }
    };
    fetchEmployeeBy();
  }, []);
  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <div>
            <Button
              leftSection={<IconReload size={14} />}
              variant="blue"
              disabled={!isHaveNewOrder}
              mr={"xs"}
              onClick={() => {
                fetchData();
                setIsHaveNewOrder(false);
              }}
            >
              Cập nhật đơn mới
            </Button>
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              onClick={() => {
                if (form.getValues()?.StartDate && form.getValues()?.EndDate) {
                  const search = form.getValues();
                  const queryParams = {
                    Skip: pagination.pageIndex * pagination.pageSize,
                    Take: pagination.pageSize,
                    InvId: search.invId ? search.invId.toString() : "",
                    InvOutwardId: search.invOutwardId
                      ? search.invOutwardId.toString()
                      : "",
                    CustomerId: search.customerId
                      ? search.customerId.toString()
                      : "",
                    StartDate: search.StartDate
                      ? moment(search?.StartDate).format(
                          "YYYY-MM-DDT00:00:00.000[Z]",
                        )
                      : "",
                    EndDate: search.StartDate
                      ? moment(search?.EndDate).format(
                          "YYYY-MM-DDT00:00:00.000[Z]",
                        )
                      : "",
                    OrderStatus: search.orderStatus,
                    OrderType: search.orderType ? search.orderType : 0,
                    OrderNumber: search.orderNumber,
                    PaymentStatus: search.paymentStatus,
                    industry: search.industry,
                    OutwardStatus: search?.OutwardStatus,
                    KeySearch: search.keySearch,
                    SourceOrderType: search.SourceOrderType ? "4" : "",
                  };

                  let url;
                  url =
                    "/api/v1/CreateSellItem/export-sale-order?IsAccountant=true&" +
                    Object.entries(queryParams)
                      .filter(
                        ([, value]) => value !== undefined && value !== "",
                      )
                      .map(
                        ([key, value]) => `${key}=${encodeURIComponent(value)}`,
                      )
                      .join("&");

                  const _url = BASE_API_POS + url;

                  const fullUrl = new URL(_url);

                  const token = localStorage.getItem("token");

                  fetch(fullUrl.toString(), {
                    method: "GET", // Use the appropriate HTTP method
                    headers: {
                      Authorization: `Bearer ${token?.replace(/"/g, "")}`,
                      "Content-Type": "application/vnd.ms-excel",
                    },
                  })
                    .then((response) => {
                      if (response.ok) {
                        return response.blob(); // Assuming the response is a file or blob
                      } else {
                        throw new Error("Failed to fetch the resource");
                        NotificationExtension.Fails("Export Excel thất bại !");
                      }
                    })
                    .then((blob) => {
                      // Open the blob in a new tab
                      const url = window.URL.createObjectURL(blob);
                      const _name = new Date().toISOString().slice(0, 10);
                      let filename = "bao_cao_ban_hang" + "-" + _name + ".xlsx"; // Tên mặc định nếu không có header
                      const link = document.createElement("a");
                      link.href = url;
                      link.download = filename;
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      window.URL.revokeObjectURL(url);
                      NotificationExtension.Fails("Export Excel thành công !");
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                } else {
                  NotificationExtension.Fails(
                    "Vui lòng chọn khoảng thời gian Export Excel !",
                  );
                }
              }}
            >
              Export Excel
            </Button>
          </div>
        </Flex>
        <Grid mt={"10px"}>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("keySearch")}
              placeholder="Từ khoá"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("keySearch")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("orderNumber")}
              placeholder="Mã đơn hàng"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("orderNumber")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("codeCustomer")}
              placeholder="Mã khách hàng"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("codeCustomer")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("phone")}
              placeholder="SĐT khách hàng"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("phone")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("orderType")}
              searchable
              clearable
              placeholder="Loại đơn hàng"
              comboboxProps={{
                transitionProps: { transition: "fade-up", duration: 200 },
              }}
              leftSection={<IconMenuOrder color="#15aabf" />}
              data={orderTypes}
              nothingFoundMessage="Dữ liệu không có !"
              renderOption={renderSelectOption}
              {...form.getInputProps("orderType")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("orderStatus")}
              placeholder="Trạng thái đơn hàng"
              clearable
              leftSection={<IconStatusChange color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={orderStatuses}
              {...form.getInputProps("orderStatus")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={dataBranch.length || form.key("invId")}
              searchable
              clearable
              placeholder="Chi nhánh"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              data={dataBranch.map((item) => {
                return {
                  label: item.text,
                  value: item.value,
                };
              })}
              {...form.getInputProps("invId")}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              key={listEmployeeSales.length || form.key("CodeSal")}
              placeholder="Tìm người hưởng số"
              data={listEmployeeSales}
              {...form.getInputProps("CodeSal")}
              // onChange={(value) => {
              //   handleChangeSearchReturn(String(value || ""), "CodeSal");
              // }}
              leftSection={<IconSearch color="#15aabf" />}
              clearable
              searchable
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              key={form.key("StartDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              {...form.getInputProps("StartDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("EndDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              {...form.getInputProps("EndDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("FinishDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Thời gian hoàn thành đơn"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("FinishDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("OwDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Ngày xuất kho"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("OwDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("VourcherCode")}
              placeholder="Mã vourcher"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("VourcherCode")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("SalePhone")}
              placeholder="SĐT người bán"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("SalePhone")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("SortType")}
              placeholder="Sắp xếp"
              data={[
                { label: "Mặc định", value: "0" },
                { label: "Ưu tiên đơn hàng duyệt", value: "1" },
              ]}
              leftSection={<IconSortAscending color="#15aabf" />}
              clearable
              {...form.getInputProps("SortType")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Flex align={"center"} gap={10} wrap={"wrap"}>
              <Checkbox
                label="Đơn Mobile"
                key={form.key("SourceOrderType")}
                {...form.getInputProps("SourceOrderType", { type: "checkbox" })}
              />
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                loading={isLoading}
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default ApproveApplicationList;
